<template>
    <form>
        <form-alert />

        <div class="form-group">
            <label for="name">
                Name
            </label>
            <form-input
                v-model="mutableData.name"
                name="name"
                data-vv-as="Name"
            />
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="is_archived">
                        Status
                    </label>
                    <form-select
                        v-model="mutableData.is_archived"
                        name="is_archived"
                        :options="{ 0: 'Active', 1: 'Archived' }"
                        data-vv-as="Status"
                    />
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label for="category">
                        Category
                    </label>
                    <form-select
                        v-model="mutableData.category"
                        name="category"
                        :options="categoryOptions"
                        data-vv-as="Category"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="mutableData.filename"
            class="form-group"
        >
            <label for="file">
                Current File
            </label>
            <p>
                <router-link
                    :to="mutableData.url_download"
                    target="_blank"
                    class="btn btn-primary"
                >
                    Download {{ mutableData.filename }}
                </router-link>
            </p>
        </div>

        <div class="form-group">
            <label for="file">
                Replace File
            </label>
            <div class="custom-file">
                <input
                    id="file"
                    ref="file"
                    type="file"
                    class="custom-file-input"
                    @change="handleFileUpload()"
                />
                <label
                    class="custom-file-label"
                    for="file"
                >
                    Choose file
                </label>
            </div>
        </div>

        <LanguagesForm
            v-if="mutableData.id"
            v-model:languages-selected="mutableData.languages_selected"
        />

        <form-alert />

        <button
            :disabled="isSending"
            class="btn btn-success btn-block"
            @click.prevent="submitMultiPartForm()"
        >
            Save
        </button>
    </form>
</template>

<script>
import bsCustomFileInput from "bs-custom-file-input";
import Form from "../mixins/Form.js";
import LanguagesForm from "./LanguagesForm.vue";

export default {
    components: {
        LanguagesForm,
    },

    mixins: [
        Form,
    ],

    data() {
        return {
            categoryOptions: {
                "series-image": "Series image",
                "visual-aids": "Visual aids",
                "language-pack": "Language pack",
                "activity-pack": "Activity Pack",
                "game-resource": "Game Resource",
            },
        };
    },

    mounted() {
        // displays filename in <input>
        $(document).ready(() => {
            bsCustomFileInput.init();
        });
    },

    methods: {
        handleFileUpload() {
            this.files = {
                file: this.$refs.file.files[0],
            };
        },
    },
};
</script>
